import React from 'react';
import { Minimize2, X, History } from 'lucide-react';
import { IconButton } from '@/components/ui';
import { ChatbotIcon } from '../atoms';

interface ChatHeaderProps {
  title?: string;
  onMinimize?: () => void;
  onClose?: () => void;
  onShowHistory?: () => void;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({
  title = 'Asistente Virtual',
  onMinimize,
  onClose,
  onShowHistory,
}) => {
  return (
    <div className="flex items-center justify-between p-4 bg-primary-600 text-white rounded-t-lg">
      <div className="flex items-center space-x-2">
        <ChatbotIcon size="sm" className="text-white" />
        <h3 className="font-semibold text-sm">{title}</h3>
      </div>
      <div className="flex items-center space-x-1">
        {onShowHistory && (
          <IconButton
            icon={History}
            onClick={onShowHistory}
            variant="ghost"
            size="sm"
            className="text-white hover:bg-primary-700"
            aria-label="Ver historial"
            title="Historial de conversaciones"
          />
        )}
        {onMinimize && (
          <IconButton
            icon={Minimize2}
            onClick={onMinimize}
            variant="ghost"
            size="sm"
            className="text-white hover:bg-primary-700"
            aria-label="Minimizar"
          />
        )}
        {onClose && (
          <IconButton
            icon={X}
            onClick={onClose}
            variant="ghost"
            size="sm"
            className="text-white hover:bg-primary-700"
            aria-label="Cerrar"
          />
        )}
      </div>
    </div>
  );
};

export default ChatHeader;

